import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import JsonLd from './JsonLd';
import { faqs } from '../data/faqs';

const FAQSection = () => {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.question,
      acceptedAnswer: { '@type': 'Answer', text: f.answer },
    })),
  };

  return (
    <section id="faq" className="py-20 px-6 bg-white">
      <JsonLd id="home-faq" data={faqSchema} />
      <div className="max-w-4xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <div className="w-24 h-1 mx-auto mb-6" style={{ backgroundColor: '#00B3B3' }} />
          <p className="text-gray-600 text-lg">
            Got questions? We&apos;ve got answers!
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="border border-gray-200 rounded-lg px-6 shadow-sm hover:shadow-md transition-shadow"
            >
              <AccordionTrigger className="text-left font-semibold text-gray-900 hover:no-underline py-4">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed pb-4">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Still Have Questions CTA */}
        <div
          className="text-center mt-12 p-6 rounded-lg"
          style={{ backgroundColor: 'rgba(0, 179, 179, 0.05)' }}
        >
          <p className="text-gray-700 mb-4">
            Still have questions? We&apos;re here to help!
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <a
              href="tel:2244199922"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105"
              style={{
                backgroundColor: '#00B3B3',
                color: 'white',
                textDecoration: 'none',
              }}
            >
              Call Us: (224) 419-9922
            </a>
            <a
              href="mailto:info@nexerarepair.com"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-semibold border-2 transition-all duration-300 hover:scale-105"
              style={{
                borderColor: '#00B3B3',
                color: '#00B3B3',
                textDecoration: 'none',
              }}
            >
              Email Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
